var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"router-view"}),(_vm.showPreviewImg)?_c('vue-picture-viewer',{attrs:{"img-data":_vm.previewImgs,"select-index":_vm.previewIndex},on:{"close-viewer":function($event){_vm.showPreviewImg=false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }